import React from 'react'
import styles from './Coin.module.css'

export default ({ type, value }) => (
  <div className={styles.container} style={{ backgroundColor: type === 'gold' ? '#F5C727' : '#EAF5F1' }}>
    {value}
  </div>
)
